import React from 'react'
import t from 'format-message'
import {SimpleSelect} from '@instructure/quiz-common'
import {IconQuizLine} from '@instructure/ui-icons'
import {View} from '@instructure/ui-view'

import {navBarMenuItems} from '../../../../util/navigation'
import {useTheme} from '@instructure/emotion'
import {TopNavBar} from '@instructure/ui-top-nav-bar'
import {useMediaQuery} from 'usehooks-ts'
import {useLocation, useNavigate, useParams} from 'react-router'
import {useBasename} from '../../../../native/useBasename'

type NavigationProps = {
  isSurvey: boolean
}

export function Navigation({isSurvey}: NavigationProps): JSX.Element {
  const isSmallScreen = useMediaQuery('(max-width: 700px)')
  const theme = useTheme()
  const navigate = useNavigate()
  const {pathname} = useLocation()
  const {activeAssignmentId} = useParams()
  const {basename} = useBasename()

  // @ts-expect-error Typescript is not fully setup in this codebase.
  function handleSelectChange(_event, option): void {
    navigate(option.value)
  }

  // @ts-expect-error Typescript is not fully setup in this codebase.
  function handleMenuItemClick(event, item): void {
    event.preventDefault()
    navigate(item.path)
  }

  const menuItems = navBarMenuItems(activeAssignmentId, isSurvey)

  if (isSmallScreen) {
    return (
      <SimpleSelect
        value={pathname}
        onChange={handleSelectChange}
        theme={{borderStyle: 'none'}}
        renderLabel={t('Navigation')}
        size="small"
      >
        {menuItems.map(item => (
          <SimpleSelect.Option value={item.path} id={item.text.replace(/ /g, '-')} key={item.text}>
            {item.text}
          </SimpleSelect.Option>
        ))}
      </SimpleSelect>
    )
  }

  return (
    <View width="100%" as="div">
      <TopNavBar inverseColor breakpoint={0} mediaQueryMatch="element">
        {() => {
          return (
            <TopNavBar.Layout
              navLabel={t('Quiz navigation bar')}
              smallViewportConfig={{
                dropdownMenuToggleButtonLabel: t('Quiz mobile navigation menu'),
              }}
              themeOverride={{
                // @ts-expect-error Typescript is not fully setup in this codebase and theme types are not yet handled.
                desktopBackgroundInverse: theme.colors.contrasts.white1010,
                // @ts-expect-error Typescript is not fully setup in this codebase and theme types are not yet handled.
                smallViewportBackgroundInverse: theme.colors.contrasts.white1010,
                desktopBottomBorderInverse: 'transparent',
                smallViewportBottomBorderInverse: 'transparent',
              }}
              renderBrand={
                <TopNavBar.Brand
                  screenReaderLabel={t('New Quizzes logo')}
                  renderIcon={<IconQuizLine color="primary" size="small" />}
                />
              }
              renderMenuItems={
                <TopNavBar.MenuItems
                  listLabel={t('Quiz navigation menu')}
                  renderHiddenItemsMenuTriggerLabel={hiddenChildrenCount =>
                    t('{hiddenChildrenCount} More', {hiddenChildrenCount})
                  }
                >
                  {menuItems.map(item => {
                    const isActive = item.path === pathname
                    return (
                      <TopNavBar.Item
                        href={`${basename}${item.path}`}
                        key={item.path}
                        id={`nav-link-${item.text.toLowerCase().replaceAll(' ', '-')}`}
                        status={isActive ? 'active' : 'default'}
                        aria-current={isActive ? 'page' : false}
                        onClick={event => handleMenuItemClick(event, item)}
                      >
                        {item.text}
                      </TopNavBar.Item>
                    )
                  })}
                </TopNavBar.MenuItems>
              }
            />
          )
        }}
      </TopNavBar>
    </View>
  )
}
